import { Entity } from '../index'

export class DeductibleType extends Entity {
  name: string;
  description: string;
  amount: number;
}
